import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';

export interface DeleteConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  title: string;
  message: string;
  confirmButtonText?: string;
  closeButtonText?: string;
}

const DeleteConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmButtonText = 'Delete',
  closeButtonText = 'Cancel',
}: DeleteConfirmationModalProps) => {
  const handleConfirm = async () => {
    try {
      await onConfirm();
    } catch (error) {
      console.error('Error in delete confirmation:', error);
    }
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      slotProps={{
        paper: {
          elevation: 2,
          sx: {
            minWidth: { sm: '80%', md: '400px' },
            m: 2,
          },
        },
      }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography sx={{ whiteSpace: 'pre-line' }}>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleConfirm}
          color="error"
          variant="contained"
          autoFocus
        >
          {confirmButtonText}
        </Button>
        <Button onClick={handleClose} color="primary" variant="outlined">
          {closeButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationModal;
